module.exports = __webpack_public_path__ + "static/media/marcasr.3bf59fd1.jpg";